module.exports = __webpack_public_path__ + "handle-ziggo.6b1bc617a133ace0a442.png";


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/assets/images/handle-ziggo.png
// module id = ../../../../../src/assets/images/handle-ziggo.png
// module chunks = styles